import { Box } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import FaultReportCreationPage from "./components/FaultReportCreation/FaultReportCreationPage";
import Home from "./components/Home";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { FaultReportApi } from "./api/FaultReportApi";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { de } from "date-fns/locale";
import { GeoMapProvider } from "./context/GeoMapContext";
import { useDefaultCenter } from "./hooks/defaultcenter";
import { MaintenanceDialog, MaintenanceReportsValue } from "./components/MaintenanceDialog";
import { FullscreenSpinner } from "./parts";
import { useAppContext } from "./context/AppContext";
import { LoadingDialog } from "./parts/LoadingDialog";
import { determineAPIBaseURL } from "./api/paths";

export const GOOGLE_MAPS_API_KEY = "AIzaSyAftNYADiPyxpFok-Y9274VctC3jq_Kwg4";
const GOOGLE_MAPS_LIBRARIES = ["places", "geometry"];

function App({ maintenance, maintenanceFetched }: MaintenanceReportsValue) {
  const { isLoading } = useAppContext();
  const { defaultCenter, defaultCustomerScope } = useDefaultCenter();

  return !maintenanceFetched ? <FullscreenSpinner /> : (
    <>
      <GeoMapProvider 
        googleMapsApiKey={GOOGLE_MAPS_API_KEY}
        googleMapslibraries={GOOGLE_MAPS_LIBRARIES}
        defaultCenter={defaultCenter}
        defaultCustomerScope={defaultCustomerScope}
        defaultFetchType="center"
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
          <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_SITE_KEY} useEnterprise>
            <Box display="flex" flexDirection="column" height="100%">
              <Routes>
                <Route path="" element={<Navigate to="/start" />} />
                <Route path="/start" element={<Home />} />
                <Route
                  path="/stoerung-melden"
                  element={<FaultReportCreationPage faultReportApi={faultReportApi} />}
                />
              </Routes>
            </Box>
          </GoogleReCaptchaProvider>
        </LocalizationProvider>
      </GeoMapProvider>
      <LoadingDialog open={isLoading} />
      <MaintenanceDialog maintenance={maintenance} />
    </>
  );
}

const GOOGLE_RECAPTCHA_SITE_KEY = "6LfSxCwdAAAAANDP_6cG51fIqVU-8sVOWOphRJa2";

const faultReportApi = new FaultReportApi({ basePath: determineAPIBaseURL() || "" });

export default App;
